import React, { useContext, useEffect } from 'react';
import { 
  Route, 
  Switch, 
  Redirect,
  useHistory,
  useLocation,
 } from 'react-router-dom'; // Import Redirect if needed
import CryptoJS from 'crypto-js';
import toast from 'react-hot-toast';
import MainWrapper from '../MainWrapper';
import LogIn from '../../Account/LogIn/index';
import WrappedRoutes from './WrappedRoutes';
import { AuthContext } from '../../../context/AuthContext';
import BookingDashboard from '../../Dashboards/Booking';
import { GlobalVarContext } from '../../../context/GlobalVarContext';
import ForgotPass from '../../Account/ForgotPass';
import SignUp from '../../Account/SignUp';
import ResForm from '../../Account/ResForm';
import AgentForm from '../../Account/AgentForm';
import Dashboard from '../../Restau/Dashboard/Dashboard';
import { PermissionContext } from '../../../context/PermissionContext';
import { Mealcontext } from '../../../context/MealContext';

const Router = () => {
  const { isLoggedIn, setIsLoggedIn, userid } = useContext(AuthContext); 
  const { apiGlobalforLogin, apiGlobal } = useContext(GlobalVarContext);
  const { setPermissionsAccess } = useContext(PermissionContext);
  const history = useHistory();
  const { setActiveKey, setclick, setIsDetailsClick } = useContext(Mealcontext);
  const location = useLocation();
  
  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        const response = await fetch(`${apiGlobalforLogin}/restaurant/auth.php`);
        const data = await response.json();
        // console.log(`isLogin:${data.loggedIn}`);
        // if (data.loggedIn) {
        //   history.push('/');
        // }
        setIsLoggedIn(data?.loggedIn);
        if (data?.loggedIn) {
          const encryptedPermissions = localStorage.getItem('respermissions');
                if (encryptedPermissions) {
                  try {
                    const bytes = CryptoJS.AES.decrypt(
                      encryptedPermissions,
                      'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
                    );
                    const decryptedPermissionsString = bytes.toString(CryptoJS.enc.Utf8);
           
                    if (decryptedPermissionsString) {
                      const permissionsAccess = JSON.parse(decryptedPermissionsString);
                      setPermissionsAccess(permissionsAccess);
                    }
                  } catch (error) {
                    console.error('Decryption error:', error);
                  }
                }
        } else if (!data?.loggedIn) {
            localStorage.clear();
            sessionStorage.clear();
          
            // Clear Cookies
            document.cookie.split(';').forEach((cookie) => {
              const name = cookie.split('=')[0].trim();
              document.cookie = `${name }=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
            });
      
            if ('caches' in window) {
              caches.keys().then((names) => {
                // eslint-disable-next-line
                for (const name of names) {
                  caches.delete(name);
                }
              });
            }
          }
      } catch (error) {
        console.error('Error checking login status:', error);
        setIsLoggedIn(false);
      }
    };

    checkLoginStatus();
  }, []); 

  useEffect(() => {
    if (location.pathname !== '/restaurant/meal') {
      setActiveKey('1');
      setclick('searchSelect');
      setIsDetailsClick(false);
    }
}, [location]);

const blockUserHandler = async () => {
   if (!userid) return; // Prevent unnecessary API calls if agentId is undefined/null

  const formdata = new FormData();
  formdata.append('user_id', userid);
  try {
    const url = await fetch(`${apiGlobal}restaurant/user_restaurant_block.php`, {
      method: 'POST',
      body: formdata,
    });
    const response = await url.json();
    console.log(response);
  } catch (error) {
    console.log(error);
  }
};

  
// Define Protected Paths
const protectedPaths = [
  '/signup',
  '/forgot_password',
  '/',
  '/restaurant/restaurant',
  '/app_dashboard',
  '/login',
  '/restaurant/meal',
  '/restaurant/account',
  '/restaurant/booking',
  '/usermanager/users',
  '/restaurant/request',
  '/restaurant/resRejectedRequest',
  '/usermanger/management',
  '/restaurant/accountrejectrequest',
  '/restaurant/accountrequest',
  '/restaurant/accountapproved',
];

  const onlogoutHandler = async () => {
     const url = await fetch(`${apiGlobalforLogin}/restaurant/logout.php`);
     const response = await url.json();
     if (response.loggedOut === true) {
       setIsLoggedIn(false);
       toast.success('Logout Successfull Redirecting....');
       localStorage.clear();
       setTimeout(() => {
         history.push('/');
       }, 2000);
     } else {
      toast.error('Something Went Wrong....');
     }
  };


// Handle Suspicious Activity (If the route is not in protectedPaths)
useEffect(() => {
  if (!protectedPaths.includes(location.pathname)) {
    // eslint-disable-next-line
    let suspectedCount = parseInt(localStorage.getItem('erereddf')) || 0;
    suspectedCount += 1;
 
    localStorage.setItem('erereddf', suspectedCount.toString());
 
    if (suspectedCount > 2) {
      blockUserHandler();
      onlogoutHandler();
      
      // setIsLoggedIn(false);
    }
  }
}, [location.pathname]); // Runs when the pathname changes

  return (
    <MainWrapper>
      <main>
        <Switch>
    
          {/* <Route exact path="/" component={isLoggedIn ? AppDashboard : LogIn} />
          <Route path="/forgot_password" component={ForgotPass} />
          {/* <Route path="/sign_up" component={SignUp} /> */}
          {/* <Route path="/signup" component={ResForm} />
          <Route path="/" component={isLoggedIn ? WrappedRoutes : LogIn} /> */}
          <Route 
            exact 
            path="/"
            render={() => (
              isLoggedIn ? <Redirect to="/app_dashboard" /> : <LogIn />
          )}
          />

          <Route 
            path="/signup"
            component={ResForm}
          />
          <Route 
            path="/forgot_password"
            component={ForgotPass}
          />

          <Route
            path="/app-dashboard"
            render={() => (
            isLoggedIn ? <Dashboard /> : <LogIn />
          )}
          />

          {/* Catch-all route (not logged in, send to login page) */}
          <Route
            path="*"
            render={() => (
            isLoggedIn ? <WrappedRoutes /> : <LogIn />
          )}
          />
          

        </Switch>
      </main>
    </MainWrapper>
 );
};

export default Router;
